<script setup>
import CertificationsAdminComponent from "@/Components/Certifications/CertificationsAdminComponent.vue";
import AutoSharingManageComponent from "@/Components/AutoSharing/AutoSharingManageComponent.vue";

import {Permissions} from "@/Utils/Permissions";

</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-row>
      <v-col cols="6" v-if="Permissions.checkPermissions(['certifications.read-admin'])">
        <CertificationsAdminComponent contextSchemaA=""/>
      </v-col>
      <v-col cols="6" v-if="Permissions.checkPermissions(['autosharing.list'])">
        <AutoSharingManageComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>